/**
 * Monaco editor bootstrap.
 *
 * By default, `@monaco-editor/react` lazily fetches the `monaco-editor` runtime
 * from the jsdelivr CDN at first render. The download has no integrity check,
 * so a compromise of jsdelivr would compromise the portal.
 *
 * To mitigate this, the Vite build copies Monaco's pre-minified npm
 * distribution into a versioned `/monaco/<version>/vs` path. The loader
 * fetches the editor and workers from the portal's own origin, so no
 * third-party CDN is contacted at runtime. Versioning keeps the assets safe
 * for immutable caching across upgrades and rollbacks.
 *
 * This module must be imported once at app startup, before any Monaco-backed
 * component (e.g. `FileEditorModal`) renders.
 *
 * @module config/monaco
 */
import { loader } from '@monaco-editor/react';

/**
 * Tell `@monaco-editor/loader` to use the npm-installed static assets instead
 * of downloading them from jsdelivr.
 */
loader.config({
  paths: {
    vs: `/monaco/${__MONACO_VERSION__}/vs`,
  },
});
